const api_key = process.env.REACT_APP_API_KEY;

const AdminAuthCheck = async () => {
  const token = localStorage.getItem("admin_ads_manager");
  try {
    const resp = await fetch("/api/admin/auth/check", {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-api-key": api_key,
      },
    });
    return await resp.json();
  } catch (error) {
    console.error("Admin Auth Check" + error);
    return { status: false, message: "Internet Server Error" };
  }
};

const AdminLogin = async (body) => {
  try {
    const resp = await fetch("/api/admin/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": api_key,

      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    console.error("Admin Login" + error);
    return { status: false, message: "Internet Server Error" };
  }
};

const updateAdminPw = async (body) => {
  const token = localStorage.getItem("admin_ads_manager");
  try {
    const resp = await fetch(`/api/admin/change/pw`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-api-key": api_key,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

// Get Profile Data
const getAllProfile = async () => {
  const token = localStorage.getItem("admin_ads_manager");
  try {
    const resp = await fetch(`/api/ads/profile`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-api-key": api_key,
      },
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

const getProfile = async (id) => {
  const token = localStorage.getItem("admin_ads_manager");
  try {
    const resp = await fetch(`/api/ads/profile?id=${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-api-key": api_key,
      },
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

const addProfile = async (formdata) => {
  const token = localStorage.getItem("admin_ads_manager");
  try {
    const resp = await fetch(`/api/ads/profile`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-api-key": api_key,
      },
      body: formdata,
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

const deleteProfile = async (id) => {
  const token = localStorage.getItem("admin_ads_manager");
  try {
    const resp = await fetch(`/api/ads/profile/${id}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-api-key": api_key,
      },
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

const updateProfile = async (id, formdata) => {
  const token = localStorage.getItem("admin_ads_manager");
  try {
    const resp = await fetch(`/api/ads/profile/${id}`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-api-key": api_key,
      },
      body: formdata,
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

// Ads
const addAds = async (formdata) => {
  const token = localStorage.getItem("admin_ads_manager");
  try {
    const resp = await fetch(`/api/ads/admin`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-api-key": api_key,
      },
      body: formdata,
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

const updateAds = async (formdata) => {
  const token = localStorage.getItem("admin_ads_manager");
  try {
    const resp = await fetch(`/api/ads/admin`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-api-key": api_key,
      },
      body: formdata,
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

const getAds = async (
  page = null,
  limit = null,
  q = null,
  id = null,
  profile = null
) => {
  const token = localStorage.getItem("admin_ads_manager");
  try {
    const resp = await fetch(
      `/api/ads/admin?page=${page}&limit=${limit}&q=${q}&profile=${profile}${
        !id ? "" : "&id=" + id
      }`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "x-api-key": api_key,
        },
      }
    );
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

const deleteAds = async (body) => {
  const token = localStorage.getItem("admin_ads_manager");
  try {
    const resp = await fetch(`/api/ads/admin`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-api-key": api_key,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

const deleteAdsTrack = async (id) => {
  const token = localStorage.getItem("admin_ads_manager");
  try {
    const resp = await fetch(`/api/ads/admin/remove/track/${id}`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-api-key": api_key,
        "Content-Type": "application/json",
      },
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

// DashBoard Data
const adminDashbordWithId = async (id, startDate, endDate) => {
  const token = localStorage.getItem("admin_ads_manager");
  try {
    const resp = await fetch(
      `/api/ads/admin/dashbord/${id}?startDate=${startDate}&endDate=${endDate}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "x-api-key": api_key,
        },
      }
    );
    return await resp.json();
  } catch (error) {
    console.log(error);
    return { status: false, message: "Internet Server Error" };
  }
};

const adminDashbord = async (id = null, startDate, endDate) => {
  const token = localStorage.getItem("admin_ads_manager");
  try {
    const resp = await fetch(
      `/api/ads/admin/dashbord/all/${
        id || "all"
      }?startDate=${startDate}&endDate=${endDate}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "x-api-key": api_key,
        },
      }
    );
    return await resp.json();
  } catch (error) {
    console.log(error);
    return { status: false, message: "Internet Server Error" };
  }
};

const Calling = {
  AdminLogin,
  AdminAuthCheck,
  updateAdminPw,
  getAllProfile,
  addProfile,
  deleteProfile,
  updateProfile,
  getProfile,
  addAds,
  getAds,
  updateAds,
  deleteAds,
  adminDashbord,
  adminDashbordWithId,
  deleteAdsTrack,
};

export default Calling;
